<template>
  <div id="ViewFiles" dir="rtl">
    <panel
      class="no-print"
      Title="فرم‌ها و فایل‌های جانبی"
      Des="از این بخش می‌توانید فرم‌ها و فایل‌های مورد نیاز خود را دریافت کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-folder-open"></i>
          فرم‌ها و فایل‌های جانبی
        </h6>
      </template>
      <template slot="content">
        <files-list></files-list>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from "../../Tools/NetPa/NetPaCard.vue";
import Panel from "../../Tools/NetPa/Panel.vue";
import FilesList from "./FilesList.vue";

export default {
  components: {
    NetPaCard,
    Panel,
    FilesList,
  },
};
</script>
